import { z } from "zod";

export const DeploymentCountryItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  TwoLetterCode: z.string().optional(),
  ThreeLetterCode: z.string().optional(),
});

export type DeploymentCountryItemType = z.infer<
  typeof DeploymentCountryItemSchema
>;
